import React, { Component } from "react";
import { connect } from 'react-redux';
import * as actionCreators from '../../../../modules/actions/index';
import * as url from '../../../../utils/url';
import MapGender from '../../../../components/OrganizationSetup/MapGender/MapGender';

class MapGenderSetup extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleFileUpload = (columns, data, file) => {
    // console.log("file- ",columns, '---', data, '---',file)
      this.props.onFileDataProcessed(columns, data, file);
  }

  handleMatchColumn = (matchedColumn) => {
    this.props.onMatchColumn(matchedColumn);
  }

  componentWillUnmount() {
    this.props.resetMapGenderStep();
  }

  render() {
    return (<div className="mb20 mt60">
      <MapGender
        onProcessedFileUploadData={this.handleFileUpload}
        onMapGenderMatchColumn={this.handleMatchColumn}
        {...this.props} />
    </div>);
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.profile,
    mapGender: state.mapping.gender
  }
}

const mapDispatchToProps = dispatch => {
	return {
    resetMapGenderStep: () => dispatch(actionCreators.resetMapGenderStep()),
    nextStep: () => dispatch(actionCreators.mapGenderNextStep()),
    goBack : () => dispatch(actionCreators.mapGenderGoBack()),
    saveAllGenderMapping : (m) => dispatch(actionCreators.saveAllGenderMapping(m)),
    onFileDataProcessed: (c,d,f) => dispatch(actionCreators.mapGenderUploadFileSuccess(c,d,f)),
    onMatchColumn: data => dispatch(actionCreators.mapGenderMatchColumnSuccess(data))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(MapGenderSetup);